import { render } from "./ElHeader.vue?vue&type=template&id=48a69b68"
import script from "./ElHeader.vue?vue&type=script&lang=js"
export * from "./ElHeader.vue?vue&type=script&lang=js"

import "./ElHeader.vue?vue&type=style&index=0&id=48a69b68&lang=scss"

import exportComponent from "D:\\angren\\admit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__